import isUrl from 'is-url';
import IsEmail from 'isemail';

const validations = {
    maxLength(value, length) {
        return !validations.exists(value) || value.length <= length;
    },

    isEmpty: (value) => value === '',

    exists: (value) => value !== null && value !== undefined,

    isEmail: (value) => value && IsEmail.validate(value),
    isUrl: (value) => value && isUrl(value),

    matchRegexp: (value, regexp) =>
        !validations.exists(value) ||
        validations.isEmpty(value) ||
        regexp.test(value),
};

export default validations;
